// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  createMultiFormData,
  postAntennaComment,
  postRadioComment,
  postPathComment,
} from 'helpers/api'

const createComment = async (f, dbSet, entityId) => {
  const formData = createMultiFormData(f)

  const fetchMethod = ({
    antenna: postAntennaComment,
    path: postPathComment,
    radio: postRadioComment,
  })[dbSet]

  if (!fetchMethod) {
    throw new Error('Save failed. Unmapped fetch method in createComment.')
  }

  const { entity } = await fetchMethod(entityId, formData)
  return entity
}

export default createComment
